import React from "react";
// import HTML from "../assets/HTML.svg";
// import CSS from "../assets/CSS.svg";
import JS from "../assets/JS.svg";
import NodeJS from "../assets/NodeJS.svg";
import ReactJS from "../assets/ReactJS.svg";
import MongoDB from "../assets/MongoDB.svg";
// import Ethereum from "../assets/Ethereum.svg";
// import Polygon from "../assets/Polygon.svg";
// import Bitgert from "../assets/Bitgert.svg";
import Solidity from "../assets/Solidity.svg";
import Hardhat from "../assets/Hardhat.svg";
// import Ethers from "../assets/Ethers.svg";
import Python from "../assets/Python.svg";
import Arduino from "../assets/Arduino.svg";

const Skills = () => {
  return (
    <div className="w-full md:h-screen bg-[#0B0F1F] text-gray-300">
      <div className="max-w-[1000px] mx-auto p-4 flex flex-col justify-center w-full h-full scale-95">
        <div>
          <div className="max-w-6xl mx-auto h-48">
            <h1
              name="skills"
              className="text-5xl md:text-8xl font-bold py-20 text-center md:text-left text-[#cf6c2f]"
            >
              Skills
            </h1>
          </div>
          <p className="text-2xl md:text-3xl text-[#8892b0]">
            # Technologies that I've worked with
          </p>
        </div>
        <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-4 text-center py-4">
          <div className="shadow-md shadow-[#000000] hover:scale-110 duration-500">
            <img className="w-20 h-20 mx-auto" src={Python} alt="Python" />
            <p className="my-4">Python</p>
          </div>
          <div className="shadow-md shadow-[#000000] hover:scale-110 duration-500">
            <img className="w-20 h-20 mx-auto" src={JS} alt="JavaScript" />
            <p className="my-4">JavaScript</p>
          </div>
          <div className="shadow-md shadow-[#000000] hover:scale-110 duration-500">
            <img className="w-20 h-20 mx-auto" src={ReactJS} alt="ReactJS" />
            <p className="my-4">ReactJS</p>
          </div>
          <div className="shadow-md shadow-[#000000] hover:scale-110 duration-500">
            <img className="w-20 h-20 mx-auto" src={NodeJS} alt="NodeJS" />
            <p className="my-4">NodeJS</p>
          </div>
          <div className="shadow-md shadow-[#000000] hover:scale-110 duration-500">
            <img className="w-20 h-20 mx-auto" src={MongoDB} alt="React JS" />
            <p className="my-4">MongoDB</p>
          </div>
          <div className="shadow-md shadow-[#000000] hover:scale-110 duration-500">
            <img className="w-20 h-20 mx-auto" src={Solidity} alt="Solidity" />
            <p className="my-4">Solidity</p>
          </div>
          <div className="shadow-md shadow-[#000000] hover:scale-110 duration-500">
            <img className="w-20 h-20 mx-auto" src={Hardhat} alt="Hardhat" />
            <p className="my-4">Hardhat</p>
          </div>
          <div className="shadow-md shadow-[#000000] hover:scale-110 duration-500">
            <img className="w-20 h-20 mx-auto" src={Arduino} alt="Arduino" />
            <p className="my-4">Arduino</p>
          </div>
          {/* <div className="shadow-md shadow-[#000000] hover:scale-110 duration-500">
            <img className="w-20 h-20 mx-auto" src={Ethers} alt="Ethers" />
            <p className="my-4">Ethers</p>
          </div>
          <div className="shadow-md shadow-[#000000] hover:scale-110 duration-500">
            <img className="w-20 h-20 mx-auto" src={Solidity} alt="Solidity" />
            <p className="my-4">Solidity</p>
          </div>
          <div className="shadow-md shadow-[#000000] hover:scale-110 duration-500">
            <img className="w-20 h-20 mx-auto" src={Hardhat} alt="Hardhat" />
            <p className="my-4">Hardhat</p>
          </div>
          <div className="shadow-md shadow-[#000000] hover:scale-110 duration-500">
            <img className="w-20 h-20 mx-auto" src={Ethers} alt="Ethers.js" />
            <p className="my-4">Ethers.js</p>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Skills;
